import React, { PureComponent } from "react";
import { Menu, Dropdown, Button, Icon } from "antd";
import "./quickLinks.css";
import history from "../../../../../history/history";
import { selectHeader } from "../../../../../actions/globalActions";
import { setTimeout } from "timers";
import { connect } from "react-redux";
import { isGeminiUser } from "../../../../../utils/sessionUtil";
import { recordError } from "../../../../../utils/commonUtil";
import { PropTypes } from "prop-types";

export class QuickLinks extends PureComponent {
  state = {
    dropdownOpen1: false,
    dropdownOpen2: false,

    quickLinksData2: [
      { id: 0, text: "My account details", link: "./my-account" },
      { id: 1, text: " My documents", link: "./my-account/my-documents" },
      {
        id: 2,
        text: "Transaction Summary",
        link: "/my-account/transaction-summary"
      }
    ]
  };

  // Check enitity is organization
  checkOrganizationEntity = navBarData =>
    navBarData && navBarData.entityType.toLowerCase() === "organization";

  checkDisableMenuItemsForCSR = menuItem => {
    const { navBarData, accountRole } = this.props;
    let criteraia = { disable: false, showErrorMsg: false };
    if (!isGeminiUser()) return criteraia;
    // Disable My account details when account role is primary account donor
    if (menuItem === "My account details" && accountRole === "Donor")
      return {
        disable: true,
        showErrorMsg: "Donors without account access cannot view this page."
      };
    // Disable My account details organization entitity
    if (
      menuItem === "My account details" &&
      this.checkOrganizationEntity(navBarData)
    )
      return { disable: true, showErrorMsg: false };
    //Disable my account details when no web access and primary account donor only
    if (
      menuItem === "My account details" &&
      navBarData &&
      !navBarData.webAccess &&
      navBarData.isPrimaryAccountDonorOnly
    )
      return { disable: true, showErrorMsg: false };
    return criteraia;
  };

  componentWillMount() {}
  handleMenuClick(e) {}

  navigateToLink(id, link) {
    try {
      if (id == 1) {
        this.props.selectHeader("My Documents");
        history.push(link);
      } else if (id == 2) {
        this.props.selectHeader("Transaction Summary");
        history.push(link);
      } else {
        this.props.selectHeader("Account Details");
        history.push(link);
      }
    } catch (error) {
      recordError(error);
    }
  }

  handleDropdownClick() {
    try {
      window.dataLayer = [];
      window.dataLayer.push({
        event: "manageaccountdonor"
      });
      let dropdown_width =
        document.getElementsByClassName("quicklinks-dropdown")[0].clientWidth - 2;
  
      setTimeout(function() {
        document.getElementById("quicklinks_dropdown").style.width =
          dropdown_width + "px";
      }, 1);
    } catch (error) {
      recordError(error);
    }
  }

  render() {
    const menu2 = (
      <Menu onClick={this.handleMenuClick} id="quicklinks_dropdown">
        {this.state.quickLinksData2.map(quickLinksDetail2 => {
          let csrCriteria = this.checkDisableMenuItemsForCSR(
            quickLinksDetail2.text
          );
          return (
            <Menu.Item
              title={csrCriteria.showErrorMsg ? csrCriteria.showErrorMsg : ""}
              data-test="quick-text" value={quickLinksDetail2.text}
              onClick={() =>
                this.navigateToLink(
                  quickLinksDetail2.id,
                  quickLinksDetail2.link
                )
              }
              disabled={csrCriteria.disable}
            >
              <a
                className="tool-tip"
                tabindex="0"
                className={csrCriteria.disable ? "not-allowed-cursor" : ""}
              >
                {quickLinksDetail2.text}
              </a>{" "}
            </Menu.Item>
          );
        })}
      </Menu>
    );

    return (
      <div className="displayQuicklinks">
        <Dropdown
          overlay={menu2}
          trigger={["click"]}
          onClick={this.handleDropdownClick}
          overlayClassName="quick-links-dropdown"
        >
          <Button style={{ marginLeft: 8 }}>
            Manage your account <Icon type="caret-down" />
          </Button>
        </Dropdown>
      </div>
    );
  }
}
QuickLinks.propTypes = {
  navBarData: PropTypes.any,
  accountRole: PropTypes.string
};

const mapStateToProps = state => ({
  navBarData: state.getIn(["globalState", "navBarData"]),
  accountRole: state.getIn([
    "messaging",
    "messages",
    "additionalAccountDetails",
    "accountRole"
  ])
});

export const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuickLinks);
